import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";
import Home from "./pages/Home";
import ScrollToTop from "./components/ScrollToTop";
import SlotDetail from "./pages/SlotDetail";
import StaffRoll from "./components/StaffRoll";

function App() {
  const [showStaff, setShowStaff] = useState(false);

  const handleSecretClick = () => {
    setShowStaff(true);
  };
  return (
    <>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/slot/:id" element={<SlotDetail />} />
        </Routes>
      </Router>
      <div className="hooter" onClick={handleSecretClick}>
        @copyright
        <a href="https://cluster.mu/u/diceordies_" target="blank">
          チンチロ刑務所
        </a>
      </div>
      {showStaff && <StaffRoll onClose={() => setShowStaff(false)} />}
    </>
  );
}

export default App;
